<template>
    <b-modal class="termsAndCondModal" size="lg" @hidden="onHidden"
             :hide-footer="true" :no-close-on-backdrop="false"
             v-model="showModal" title="Terms And Conditions">
        <div>
            <div class="row">
                <div class="col-12">
                    <h2>On Time Guarantee:</h2>
                    <p>If we are 30 minutes late, your ride is free. To qualify, customers must reserve online and at least 24 hours in advance. Excludes weather-related delays. Covers base fare value up to $100, and excludes tolls, tips and surcharges.</p>

                    <h2>Reservations:</h2>
                    <p>We recommend that our clients reserve a car ahead of time (at no additional charge) to be guaranteed a car at time of pick up. We can provide you with a car at short notice by phone or online upon availability.</p>

                    <h2>No-Shows:</h2>
                    <p>If you do not see your driver at a certain pick up point do not leave before calling the dispatch office, +61450899991 we will direct you to your chauffeur. If you leave without calling you will be billed for the full price of the ride (or a no-show fee). If we do not hear from you, the driver will wait up to 30 minutes at regular pickups and up to 60 minutes at inside airport pickups after the scheduled pickup time. We will then try to reach you by calling you at your cell phone, your home phone, or your contact person's phone all depending on the nature of the pickup. If we do not get a response we will then release the car and you will be billed for a No Show which will be the Full Price of the ride (or a no show fee) plus any waiting time charges. To authorize the driver to wait please call the office to authorize his wait. If we do not hear from you after the time frame, we will contact you again, if no contact is made you will get billed for the ride plus the waiting time. Therefore A "No Show" fee is equal to the trip cost plus applicable wait time fee will be charged when the passenger fails to arrive at the designated location. If you cannot locate your Driver, Please call +61450899991 to avoid a "No Show" fee.</p>

                    <h2>Damages Resulting From Your Act:</h2>
                    <p>Dooler will charge you the cost of cleaning the vehicle as result of you or your authorized party Getting Sick in, or damaging the vehicle. You also agree and acknowledge to pay all the related fees and charges to get the vehicle back to its normal working condition.</p>

                    <h2>Credit Card Transactions:</h2>
                    <p>We only take an authorization on the card to guarantee funds availability, it will show as (Pending funds) if you check your credit card account statement on-line. The authorization amount is usually higher than the expected charges in the event you decide to make some additional stops you did not inform us of or changed your destination. We will then charge your card after the trip has been completed. All receipts are sent by email.</p>

                    <h2>Disputes:</h2>

                    <p>For Corporate clients with established corporate accounts all charges of the invoice will be considered correct and due upon receipt, unless we receive an objection within 10 days from the invoice date. Copies of the vouchers under dispute should be faxed or mailed to us and the disputed charges or items should be indicated. All disputes initiated after the allowed time frame period will be considered final and non refundable.</p>
                    <p>For Individual accounts and personal profiles, all charges applied to the customer's credit card will be considered correct, unless we receive an objection within 15 days from the charge date in writing. Copies of the credit card statement or credit card slips or vouchers should be faxed or mailed to us and the disputed charges or items should be indicated. All disputes initiated after the allowed time frame period will be considered final and non refundable.</p>

                    <h2>Collection Fees:</h2>
                    <p>You agree to pay all legal counseling fees, litigation fees, legal fees, costs, accounting fees, expenses and disbursements for all actions taken prior to, during and subsequent to the initiation of legal proceedings to collect payments due incases of non-payment.</p>

                    <h2>Rates Changes:</h2>
                    <p>Dooler can change the rate book and any of the services, charges, costs, fees and expenses at any time without prior notice.</p>

                    <h2>Itemized Invoices:</h2>
                    <p>
                        For Corporate clients with established corporate accounts, Itemized invoices will be sent regularly on a net 10 (Every 15 or 30 days).
                        <br />
                        For Individual accounts and personal profiles, Itemized invoices are sent only when requested.
                    </p>

                    <h2>Payment Due Date:</h2>
                    <p>
                        For Corporate clients with established corporate accounts, All payments should be received no later than 15 days from the invoice date unless otherwise agreed on in the contract. Payments not received within the time frame allowed shall occur interest charges added of 18% yearly or 1.5% monthly.
                        <br />
                        For Individual accounts and personal profiles, All payments should be received after executing the ride. For credit card holders the total charge will be charged to their credit card after completion of ride.
                    </p>

                    <h2>Point To Point Fare:</h2>
                    <p>Those are prices calculated based on mileage and zones. Corporate accounts that meet the minimum usage requirements might be eligible for special discounts depending on volume. Check with an account sales representative for special pricing.</p>

                    <h2>Hourly Rates:</h2>
                    <p>
                        Packages of Vehicles rented hourly. Certain hourly minimums and zones restrictions apply.
                        <ul>
                            <li>Hourly services provided have a 3-hour minimum. (Weekends and Holidays may have a longer minimum hourly requirement, please call or email us to confirm.) Hourly charge is calculated based on the time vehicle is scheduled to pick up in the Australia to when the vehicle drops off in the Australia. (If your pickup or drop off destination is outside of same City you may incur a travel time charge).</li>
                            <li>One-way transfer service may not be available on weekends, holidays and during special events.</li>
                            <li>Prices vary by date and vehicle availability. (For seasonal events such as graduations and weddings, be sure to reserve early.)</li>
                        </ul>
                    </p>

                    <h2>Waiting Time:</h2>
                    <p>
                        A 45 minutes for domestic, 60 minutes International grace period is allowed following the reported flight arrival time for airport pickups only.
                        <br />
                        A 30 minute grace period is granted for all other pick-ups. Waiting time will be charged at 15 minute increments after the grace period.
                        <br />
                        Dooler checks all domestic and international flights one hour before the driver is dispatched, billing starts after grace period allowed from the official time of arrival (ETA).
                        <br />
                        For train station pick-ups, train schedules can't be monitored. Therefore, billing begins at the scheduled pick-up time.
                    </p>

                    <h2>Stops:</h2>
                    <p>Price per stop varies based on distance and location, please call us to request pricing. Courtesy stops, such as briefly leaving the vehicle to pick up coffee, a newspaper or to mail a letter, do not incur extra charges. However, if longer stops or multiple stops are made you will be billed stop charges. Picking up additional passengers will also incur stop charges.</p>

                    <h2>Tolls:</h2>
                    <p>All round trip tolls are billed to the customer depending on the route chosen. Dooler will charge for all round trip tolls to and from the designated destination. Dooler only collects the tolls, We do not charge them.</p>

                    <h2>Meet & Greet:</h2>
                    <p>Meet and Greet Airport Service is offered at an additional charge. parking and waiting time charges (if incurred) will be billed to your account or credit card. The driver will be instructed to meet the passenger by the baggage claim or the exit of customs with a sign that has his or her last name on it, the driver will then escort the passenger to the designated vehicle location (Assisting with the luggage). This package comes with a complimentary 45 minutes free for domestic flights and 60 minutes free for international flights from the arrival time.</p>

                    <h2>Parking:</h2>
                    <p>
                        All parking fees and other airport regulatory fees are additional (usually $12.00-$30.00 depending on time). We do not charge them, these fees go directly
                        to the airport parking lots.
                    </p>

                    <h2>Gratuity:</h2>
                    <p>A 10% tip (gratuity) is added to every trip, there is no need to tip anything additional to the drivers unless you would like to.</p>

                    <h2>Baby Seats:</h2>
                    <p>
                        Dooler recommends that parents get their own baby seats however we can provide one for an additional $25 per seat (please mention that you will need a
                        baby seat when you place your reservation).
                    </p>

                    <h2>Holidays Surcharges:</h2>
                    <p>
                        Holiday and Severe Weather surcharge, may be applied to trips occurring on:
                        <ul>
                            <li> New Year's Day</li>
                            <li>Memorial Day</li>
                            <li>Labor Day</li>
                            <li>Christmas Day</li>
                            <li>Fourth of July</li>
                            <li>Thanksgiving Day</li>
                        </ul>
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col text-center">
                    <button type="button" class="btn btn-primary" @click="onHidden()">Close</button>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    //import CustomerContactForm from './customerContactForm.vue'
    
    export default {
        name: "termsAndCondModal",
        data() { return { showModal: false } },
        components: { bModal },       
        watch: {
            showForm: function (newValue, oldValue) {
                this.showModal = newValue;
            }
        },
        methods: {
            onHidden: function () {
                this.$store.commit("setShowTermsAndCondModal", false);
            }            
        },
        computed: {
            showForm: function () { return this.$store.state.otherForms.showTermsAndCondModal; },
        }
    }
</script>

<style>
    .termsAndCondModal .modal {
        background: rgba(0, 0, 0, 0.62);
    }

        .termsAndCondModal .modal .modal-title {
            font-size: 35px;
            display: inline-block;
        }
</style>